/**
 * Calculate days left before account auto-lock
 * Returns the number of days remaining before 60-day inactivity lock
 */
export const calculateDaysLeftBeforeLock = (lastLoginDate?: string): number => {
  if (!lastLoginDate) {
    // If no last login date, assume 60 days (no inactivity yet)
    return 60;
  }

  const lastLogin = new Date(lastLoginDate);
  const today = new Date();
  
  // Calculate difference in milliseconds
  const diffMs = today.getTime() - lastLogin.getTime();
  
  // Convert to days
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  // Days left before lock (60 day threshold)
  const daysLeft = Math.max(0, 60 - diffDays);
  
  return daysLeft;
};

/**
 * Get inactivity status with styling recommendations
 */
export const getInactivityStatus = (daysLeft: number): {
  status: 'safe' | 'warning' | 'critical';
  message: string;
  color: string;
} => {
  if (daysLeft > 30) {
    return {
      status: 'safe',
      message: `${daysLeft} days left`,
      color: '#4caf50' // Green
    };
  } else if (daysLeft > 7) {
    return {
      status: 'warning',
      message: `${daysLeft} days left`,
      color: '#ff9800' // Orange
    };
  } else {
    return {
      status: 'critical',
      message: `${daysLeft} days left - Act now!`,
      color: '#d32f2f' // Red
    };
  }
};
